import { toast } from "react-hot-toast";

import { TOASTER_ID_KEYS } from "@/constants";

import { nextCargoApi } from "../../baseApi";
import type { Auth } from "./auth.types";

/**
 * Auth API
 * Handles authentication-related endpoints
 *
 * Nota: Os tipos são validados em auth.validation.ts
 * para garantir que todos os endpoints estão corretamente tipados
 */
export const authApi = nextCargoApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<Auth["login"]["result"], Auth["login"]["args"]>({
      query: (body) => ({
        url: "/auth/login",
        method: "POST",
        body
      }),
      onQueryStarted: async (args, { queryFulfilled }) => {
        toast.promise(
          queryFulfilled,
          {
            loading: "Autenticando...",
            success: "Autenticado com sucesso!",
            error: "Erro ao autenticar"
          },
          {
            toasterId: TOASTER_ID_KEYS.AUTH.LOGIN
          }
        );
      }
    })
  })
});
